<template>
  <div>
      <!-- Background -->
      <div class="position-absolute d-none d-lg-block top-0 right-0 -z-1" :style="{
          width: '700px',
          height: '700px',
          'clip-path': 'circle(58.2% at 60% 40%)',
      }">
          <!-- Decorativa y oculta en movil: con loading="lazy" el celular
               ni siquiera la descarga. -->
          <img :src="image" alt="Imagen señora comprando medicamento. Image by zinkevych on Freepik"
              loading="lazy" decoding="async"
              class="w-100 h-100 object-cover object-bottom-center" />
      </div>

      <!-- Content -->
      <main class="d-flex flex-column gap-2 gap-lg-20 pt-2 pt-md-5 mt-md-5">
          <!--Titulo-->
          <div class="w-100 w-lg-50">
              <h2 class="display-4 bold text-black">Encuentra tu medicamento en <span
                      class="text-primary text-nowrap">un
                      par de clics</span></h2>
              <p class="text-xl my-1">Si tienes una orden para reclamar medicamentos, busca la farmacia y los
                  medicamentos
                  abajo!</p>
          </div>

          <!-- Card con filtros -->
          <div class="d-grid bg-white grid-md-cols-3 gap-3 px-2 py-1 rounded shadow">
              <b-form-group label="Departamento">
                  <v-select label="name" class="text-lg" v-model="form.state" :options="options.states"
                      placeholder="Seleccione un departamento" />
              </b-form-group>

              <b-form-group label="Ciudad">
                  <v-select label="name" class="text-lg" v-model="form.city" :options="options.cities"
                      placeholder="Seleccione un municipio" />
              </b-form-group>

              <b-form-group label="Farmacia">
                  <v-select label="name" class="text-lg" v-model="form.customer" :options="options.customers"
                      placeholder="Seleccione una farmacia" @input="(changeEntity(form.customer))" />
              </b-form-group>

              <b-form-group label="Entidad / Eps" v-if="form.customer">
                  <v-select label="name" class="text-lg" v-model="form.entity" :options="options.entities"
                      placeholder="Seleccione una entidad" />
              </b-form-group>

              <!-- Selector de modo: se puede alternar libremente entre las dos opciones -->
              <div class="col-span-full" v-if="form.entity">
                  <p class="bold text-lg mb-1">¿Cómo quieres continuar?</p>
                  <div class="d-grid grid-md-cols-2 gap-3">
                      <button type="button" class="mode-card" :class="{ 'mode-card--active': mode === 'search' }"
                          @click="selectMode('search')">
                          <span class="mode-card__check">
                              <feather-icon :icon="mode === 'search' ? 'CheckCircleIcon' : 'CircleIcon'" size="20" />
                          </span>
                          <feather-icon icon="SearchIcon" size="26" class="mode-card__icon" />
                          <span class="mode-card__title">Yo elijo mis medicamentos</span>
                          <span class="mode-card__desc">Busca y selecciona tú mismo los medicamentos que
                              necesitas.</span>
                      </button>

                      <button type="button" class="mode-card" :class="{ 'mode-card--active': mode === 'auto' }"
                          @click="selectMode('auto')">
                          <span class="mode-card__check">
                              <feather-icon :icon="mode === 'auto' ? 'CheckCircleIcon' : 'CircleIcon'" size="20" />
                          </span>
                          <feather-icon icon="ShoppingBagIcon" size="26" class="mode-card__icon" />
                          <span class="mode-card__title">Que la farmacia los elija</span>
                          <span class="mode-card__desc">La farmacia se encargará de seleccionar tus medicamentos por
                              ti.</span>
                      </button>
                  </div>
              </div>

              <!-- Acción del modo "búsqueda" -->
              <b-form-group label="Escribe el nombre de tu medicamento" class="col-span-full" v-if="mode === 'search'">
                  <b-input-group>
                      <b-form-input v-model="form.medicine" size="lg" class="flex-grow-1"
                          placeholder="Ej. Acetaminofén 500 mg"
                          @keyup.enter="allowSearch && !isLoading && searchMedicine(2)" />

                      <template #append>
                          <b-button ref="searchBtn" @click="searchMedicine(2)" :disabled="!allowSearch || isLoading"
                              variant="primary" class="text-lg px-3">
                              <feather-icon icon="SearchIcon" size="18" /> Buscar
                          </b-button>
                      </template>
                  </b-input-group>
              </b-form-group>

              <!-- Acción del modo "avanzar sin seleccionar" -->
              <div class="col-span-full" v-if="mode === 'auto'">
                  <b-button @click="searchMedicine(1)" variant="success" size="lg" block :disabled="isLoading">
                      Continuar
                      <feather-icon icon="ArrowRightIcon" size="18" class="ml-1" />
                  </b-button>
              </div>
          </div>
      </main>

      <!-- Mostrar resultados -->
      <section ref="resultsSection" v-if="showResult && form.customer" class="mt-4">
          <div v-if="cumsAvailables.hits.length > 0">
              <Found />
              <CumsStockForm :cums="cumsAvailables" :client="form.customer" />
          </div>
          <div v-else-if="cumsNotAvailables.hits.length > 0">
              <FoundWithoutInv />
              <CumsForm :search="formatedForm" :notificar="true" :cums="cumsNotAvailables" />
          </div>

          <NotFound v-else />
      </section>

      <!-- Modal de loader -->
      <b-modal id="loadingModal" hide-footer centered static backdrop="static" :visible="isLoading">
          <div class="text-center">
              <b-spinner small type="grow"></b-spinner>
              <p class="mt-2">Procesando...</p>
          </div>
      </b-modal>
  </div>
</template>

<script>
import vSelect from "vue-select";
import image from '@images/stock/she.jpg';
import CumsForm from "@miscellaneous/cums.vue";
import CumsStockForm from "@miscellaneous/cums-stok.vue";
import LoaderButton from '@components/LoaderButton.vue';
import { Found, NotFound, FoundWithoutInv } from './msg';
import {mapMutations, mapActions, mapState} from '@/store/deliveries';

export default {
  components: {
      vSelect,
      LoaderButton,
      Found,
      NotFound,
      FoundWithoutInv,
      CumsForm,
      CumsStockForm,
  },
  data() {
      return {
          image,
          options: {
              states: [],
              cities: [],
              customers: [],
              entities: [],
          },
          form: {
              state: null,
              city: null,
              customer: null,
              medicine: null,
              entity: null,
              action: true,
          },
          isLoading: false, // Estado de carga para el loader
          showResult: false,

          cumsAvailables: {
              hits: [],
          },

          cumsNotAvailables: {
              hits: [],
          },
          mode: null, // null | 'search' | 'auto' — modo elegido en el selector
      }
  },
  methods: {
      ...mapMutations(['setCumStock', 'setCustomer']),
      ...mapActions(['saveInStorage']),
      // Rehidrata la selección previa (departamento/ciudad/farmacia/entidad)
      // cuando el usuario vuelve desde el pedido para elegir medicamentos.
      restoreForm() {
          const raw = localStorage.getItem('dataForm');
          if (!raw) return;

          let data;
          try {
              data = JSON.parse(raw);
          } catch (e) {
              return;
          }

          if (!data || !data.state || !data.city || !data.customer) return;

          // Al asignar state y city, los watchers cargan ciudades y farmacias.
          this.form.state = data.state;
          this.form.city = data.city;
          this.form.customer = data.customer;
          this.form.medicine = null;

          // Cargamos las entidades de la farmacia y conservamos la elegida.
          this.$http.get(`/entities/selects/${data.customer.id}`).then((res) => {
              this.options.entities = res.data.entities;
              this.form.entity = data.entity || res.data.entity;
              this.mode = 'search';
          });
      },
      selectMode(mode) {
          if (this.mode !== mode) {
              this.showResult = false; // al cambiar de modo ocultamos resultados previos
          }
          this.mode = mode;
          if (mode === 'auto') {
              this.form.medicine = null; // no aplica cuando la farmacia elige
          }
      },
      changeEntity(pharmacia) {
          this.mode = null;
          this.showResult = false;
          this.form.medicine = null;
          this.getEntities(pharmacia.id);
      },
      getStates() {
          this.$http.get(`/states?customers=true`).then((res) => {
              this.options.states = res.data;
          });
      },

      getCities(state_id) {
          this.$http.get(`/states/${state_id}/cities?customers=true`).then((res) => {
              this.options.cities = res.data;
          });
      },

      getEntities(pharmacia) {
          this.$http.get(`/entities/selects/` + pharmacia).then((res) => {
              this.options.entities = res.data.entities;
              this.form.entity = res.data.entity;
          });
      },

      getCustomers(stateId, cityId) {
          this.$http.post(`/customer/search`, { stateId, cityId })
              .then((res) => {
                  this.options.customers = res.data;
              });
      },

      async searchMedicine(type) {
          this.isLoading = true; // Mostrar loader
          this.showResult = false;

          try {
              const { data } = await this.$http.post(`/cum/search`, this.formatedForm);
              let { resultsWithInventory, cums } = data;

              this.cumsAvailables = resultsWithInventory;
              this.cumsNotAvailables = cums;

              if (type == 1) {
                  this.form.action = true;
                  localStorage.setItem('dataForm', JSON.stringify(this.form));
                  if(!this.storageCustomer.id){
                    this.setCustomer(this.form.customer);
                  }
                  this.saveInStorage();
                  this.$router.push({ name: 'deliveries' });

              }

              if (type == 2) {
                  this.showResult = true;
                  this.form.action = false;
                  localStorage.setItem('dataForm', JSON.stringify(this.form));
              }
          } catch (error) {
              console.error('Error durante la búsqueda:', error);
          } finally {
              this.isLoading = false; // Ocultar loader
              this.scrollToResults(); // Desplazarse a la sección de resultados
          }
      },
      scrollToResults() {
          this.$nextTick(() => {
              const resultsSection = this.$refs.resultsSection;
              if (resultsSection) {
                  resultsSection.scrollIntoView({ behavior: 'smooth' });
              }
          });
      }
  },
  watch: {
      "form.state": function (state) {
          if (state) {
              this.getCities(state.id);
          } else {
              this.form.cityId = null;
              this.options.cities = [];
          }
      },
      "form.city": function (city) {
          if (city) {
              const { state } = this.form;
              this.getCustomers(state.id, city.id);
          } else {
              this.form.customer = null;
              this.options.customers = [];
          }
      },
  },
  computed: {
      ...mapState({
          storageCustomer: 'customer', 
          storageStock: 'cumStock',
      }),
      allowSearch() {
          const { state, city, customer, medicine, entity } = this.form;
          return !!(state && city && customer && medicine && entity);
      },

      formatedForm() {
          return {
              stateId: this.form.state.id,
              cityId: this.form.city.id,
              customer: this.form.customer.id,
              name: this.form.medicine,
              entity: this.form.entity,
          };
      }
      
  },
  created() {
      this.getStates();
      if (this.$route.query.edit) {
          this.restoreForm();
      }
  },
}
</script>

<style scoped>
.mode-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  gap: 0.35rem;
  width: 100%;
  height: 100%;
  padding: 1rem 1.1rem;
  border: 2px solid #e3e6ec;
  border-radius: 0.6rem;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background-color 0.15s ease;
}

.mode-card:hover {
  border-color: #009ee0;
}

.mode-card--active {
  border-color: #009ee0;
  background: #f2fbff;
  box-shadow: 0 0 0 3px rgba(0, 158, 224, 0.12);
}

.mode-card__check {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  color: #c4c9d4;
  line-height: 0;
}

.mode-card--active .mode-card__check {
  color: #009ee0;
}

.mode-card__icon {
  color: #009ee0;
  margin-bottom: 0.15rem;
}

.mode-card__title {
  font-weight: 700;
  font-size: 1.05rem;
  color: #1a1a1a;
  padding-right: 1.5rem;
}

.mode-card__desc {
  font-size: 0.9rem;
  color: #6b7280;
  line-height: 1.3;
}
</style>